import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as actionCreators from 'actions/conversation';
import { fetchBookingsRequest } from 'actions/index';
import { bookingsData } from 'selectors/bookings';
import { userData, isCompany as isCompanySelector } from 'selectors/user';
import Main from 'components/templates/Main';
import Errors from 'components/shared/Errors';
import Success from 'components/shared/Success';
import OffersTab from '../components/OffersTab';
import ConversationTabs from '../components/ConversationTabs';
import ShowMoreButton from '../components/ShowMoreButton';

const ViewBooking = () => {
  const { conversationId } = useParams();
  const dispatch = useDispatch();
  const currentUser = useSelector(userData);
  const isCompany = useSelector(isCompanySelector);
  const bookings = useSelector(bookingsData);

  const {
    isFetching,
    error,
    uploadError,
    success,
    isPosting,
    data,
  } = useSelector((state) => (state.conversation));

  React.useEffect(() => {
    if (!isFetching) {
      dispatch(fetchBookingsRequest({ conversationId }));
    }

    if (!isFetching && isEmpty(data)) {
      dispatch(actionCreators.fetchConversationRequest({ conversationId }));
    }

    return () => {
      dispatch(actionCreators.clearConversation());
    };
  }, []);

  const isLoading = (isFetching || isEmpty(data) || isEmpty(currentUser));
  const showLoader = isLoading || !isEmpty(error);
  const loaderProps = { showLoader, isPosting };
  const isHost = currentUser.has_reviewed_cottages;

  let displayName = '';
  let otherUsers = [];

  if (!isLoading) {
    otherUsers = data.Users.filter((user) => user.id !== currentUser.id);
    displayName = otherUsers.map((user) => user.name).join(', ');
  }

  return (
    <Main
      title={displayName}
      extra={(
        data && data?.filters?.commission
          ? null
          : <ShowMoreButton data={data} isFetching={isFetching} currentUser={currentUser} />
      )}
    >
      <ConversationTabs tab={0} />
      <OffersTab
        {...loaderProps}
        {...{
          bookings,
          conversationId,
          isHost,
          isCompany,
        }}
      />
      <Errors errors={uploadError} />
      <Success
        success={success}
        onClose={() => dispatch(actionCreators.clearConversation())}
      />
    </Main>
  );
};

export default ViewBooking;
